/**
 * @license
 *
 * Copyright 2019 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *   http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/**
 * @fileoverview Define generation methods for custom blocks.
 * @author samelh@google.com (Sam El-Husseini)
 */
// More on generating code:
// https://developers.google.com/blockly/guides/create-custom-blocks/generating-code
import * as Blockly from 'blockly/core';
import 'blockly/javascript';

Blockly.JavaScript['turn'] = function (block) {
  var units = block.getFieldValue('NUM');
  var code = "await Turn(".concat(units, ");");
  return code + '\n';
};

Blockly.JavaScript['drive'] = function (block) {
  var code = "Drive();";
  return code + '\n';
};

Blockly.JavaScript['driveStop'] = function (block) {
  var code = 'DriveStop();';
  return code + '\n';
};

Blockly.JavaScript['touchSensor'] = function (block) {
  var state = block.getFieldValue('STATE');
  return ["await TouchSensor(".concat(state, ")"), 0];
};

Blockly.JavaScript['logic_waitUntil'] = function (block) {
  var conditionCode = Blockly.JavaScript.valueToCode(block, 'CONDITION', 0) || 'false';
  var code = "while (!".concat(conditionCode, ") { await sleep(.2) };");
  return code + '\n';
};

Blockly.JavaScript['logic_waitForSeconds'] = function (block) {
  var value = block.getFieldValue('NUM');
  var code = "await WaitForSeconds(".concat(value, ");");
  return code + '\n';
};

Blockly.JavaScript['shootTorpedo'] = function (block) {
  var code = "ShootTorpedo();";
  return code + '\n';
};